module.exports = __webpack_public_path__ + "static/media/profile.392f3184.svg";